"use client";

import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";
import { useAuth } from "@lib/auth/useAuth";
import { useRouteChange } from "@store/hooks/useRouteChange";
import { useStore } from "@store/index";
import { useLocale } from "next-intl";
import type { ReactNode } from "react";
import { useEffect } from "react";

export const AnalyticsProvider = ({
    pageType,
    children,
}: {
    pageType: string;
    children?: ReactNode;
}) => {
    const me = useStore((state) => state.data.me);
    const { session, isAnonymous, isAuthenticated } = useAuth();

    const locale = useLocale();

    useEffect(() => {
        AnalyticsClient.init(locale, me, session);
    }, [me, locale, session]);

    useRouteChange((url) => {
        if (typeof window !== "undefined") {
            setTimeout(() => {
                AnalyticsClient.pageView(url, pageType);
                AnalyticsClient.cartContents();
            }, 1000);
        }
    });

    useEffect(() => {
        const cookieValue = !!document?.cookie
            ?.split("; ")
            ?.find((row) => row.startsWith("CookieInformationConsent="));

        if (cookieValue) {
            setTimeout(() => {
                AnalyticsClient.handleCookiesAccepted();
            }, 3000);
        } else {
            AnalyticsClient.handleCookiesAccepted();
        }
        const currentUrl = typeof window !== "undefined" ? window.location.href : "";
        AnalyticsClient.pageView(currentUrl, pageType);
    }, []);

    useEffect(() => {
        const timerId = setTimeout(() => {
            AnalyticsClient.updateAnalyticsClientSettings(me, session);
            AnalyticsClient.saveUserData(me, session, isAuthenticated, pageType);
            AnalyticsClient.cartContents();
        }, 2000);
        return () => clearTimeout(timerId);
    }, [session?.user, isAuthenticated, isAnonymous, me?.cartInfo?.cart, me?.customer]);

    return <>{children}</>;
};
